
(() => {
  if (window.__saBstoryPick) return;
  window.__saBstoryPick = true;

  const HASH = /\/c\/vp\/([0-9a-f]{16,})\//i;
  const MOBILE_CAP = 720;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const mbps = (u) => { const m = /(\d+(?:\.\d+)?)Mbps/i.exec(u || ''); return m ? parseFloat(m[1]) : Infinity; };
  const choose = (list, need) => {
    const sorted = list.slice().sort((a, b) => a.h - b.h || mbps(a.u) - mbps(b.u));
    const fit = sorted.find((s) => s.h >= need);
    if (fit) return fit;
    return sorted.reduce((best, s) => (!best || s.h > best.h || (s.h === best.h && mbps(s.u) < mbps(best.u)) ? s : best), null);
  };

  const getJson = async (url) => {
    for (let i = 0; i < 3; i += 1) {
      let r = null;
      try { r = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }); } catch (_) { return null; }
      if (r.status === 429 && i < 2) { await sleep(1500 * (i + 1)); continue; }
      if (!r.ok) return null;

      try { return await r.json(); } catch (_) { return null; }
    }
    return null;
  };

  let catalog = null;
  const loadCatalog = () => {
    if (catalog) return catalog;
    const m = /^(.*?\/)(?:collections\/[^/]+\/)?products\/([^/?#]+)/.exec(location.pathname);
    if (!m) { catalog = Promise.resolve({}); return catalog; }
    const handle = m[2];
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || m[1].replace(/collections\/[^/]+\/$/, '') || '/';
    catalog = (async () => {
      let p = await getJson(`${root}products/${handle}.js`);
      if (!p && root !== '/') p = await getJson(`/products/${handle}.js`);
      const map = {};
      ((p && p.media) || []).forEach((md) => {
        if (md.media_type !== 'video') return;
        const mp4 = (md.sources || []).filter((s) => s.format === 'mp4' && s.url).map((s) => ({ u: s.url, h: s.height, w: s.width }));
        mp4.forEach((s) => { const h = HASH.exec(s.u); if (h) map[h[1]] = mp4; });
      });
      return map;
    })();
    return catalog;
  };

  const apply = async (host) => {
    const slides = [...host.querySelectorAll('.bstory__slide[data-video-sources]')];
    if (!slides.length) return;
    const rect = host.getBoundingClientRect();
    if (!rect.height) return;
    const map = await loadCatalog();
    const dpr = window.devicePixelRatio || 1;
    let changed = false;
    let source = 'liquid';
    slides.forEach((slide) => {
      let list = [];
      try { list = JSON.parse(slide.dataset.videoSources || '[]'); } catch (_) {  }
      const key = HASH.exec(slide.dataset.videoSrc || (list[0] && list[0].u) || '');
      if (key && map[key[1]] && map[key[1]].length) { list = map[key[1]]; source = 'api'; }
      if (!list.length) return;
      const ratio = list[0].w && list[0].h ? list[0].h / list[0].w : 1;
      const need = Math.min(rect.height, rect.width * ratio) * dpr;
      const mobile = window.matchMedia('(max-width: 768px)').matches;
      const capped = mobile ? list.filter((s) => s.h <= MOBILE_CAP) : list;
      const best = choose(capped.length ? capped : list, need);
      if (best && slide.dataset.videoSrc !== best.u) { slide.dataset.videoSrc = best.u; changed = true; }
    });
    host.dataset.videoPick = source;
    if (changed && host.embla && typeof host.syncVideo === 'function' && !host.classList.contains('is-playing')) {
      host.syncVideo(host.embla.selectedScrollSnap());
    }
  };

  const run = () => document.querySelectorAll('.bstory__media').forEach((h) => { apply(h); });
  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  let timer;
  window.addEventListener('resize', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
  document.addEventListener('shopify:section:load', run);
})();
